<template>
    <el-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="接收配置"
        width="1000px"
        append-to-body
        top="10vh"
        custom-class="dialog-body-border-bottom"
        :before-close="handleClose">
        <div class="content-wrap">
            <el-form ref="form" :model="formItem" :rules="rules"  @submit.native.prevent label-width="150px" class="pr50">
                <el-form-item label="接收方式：">
                    <el-button type="primary">邮件</el-button>
                </el-form-item>
                <el-form-item label="接收人Email：" prop="direction_email" class="label-required">
                    <el-input v-model="formItem.direction_email" placeholder="支持多个邮箱，每个邮箱使用英文逗号“,”分割"></el-input>
                </el-form-item>
                <el-form-item label="抄送人Email：" prop="email">
                    <el-input v-model="formItem.email" placeholder="支持多个邮箱，每个邮箱使用英文逗号“,”分割"></el-input>
                </el-form-item>
                <el-form-item label="邮件标题：" prop="title" class="label-required">
                    <el-input v-model="formItem.title" placeholder="请输入邮件标题" style="width:400px"></el-input>
                    <el-checkbox v-model="formItem.title_date" true-label="1" false-label="0" class="ml10">+昨日日期</el-checkbox>
                </el-form-item>
                <el-form-item label="邮件正文：" prop="body" class="label-required">
                    <WEditor ref="wEditor" :content="formItem.body"/>
                    <div class="remarks font12px mt10">
                        <p>备注：</p>
                        <div style="overflow: hidden">{__AUTO_FILL_LAST_WEEK_TOTAL__}</div>
                        <p>针对爱奇艺媒体：</p>
                        <p class="remarks_text">此字符串表示系统自动填充【账户汇总信息】与【最近7天每日汇总数据】。若去掉此字符串或字符串的格式不一致或模板未勾选账户信息与每日汇总sheet，邮件正文则不显示对应填充内容。</p>
                        <p class="mt10">针对其他媒体：</p>
                        <p class="remarks_text">此字符串表示系统按照模板指定的sheet显示对应字段的每日汇总信息，若去掉此字符串或字符串的格式不一致，邮件正文则不显示填充内容。</p>
                    </div>
                </el-form-item>
                <el-form-item label="是否发送Excel：" prop="is_send" class="label-required">
                    <el-radio-group v-model="formItem.is_send">
                        <el-radio label="1">发送</el-radio>
                        <el-radio label="0">不发送</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="Excel发送方式：" prop="is_send" v-if="formItem.is_send=='1'" class="label-required">
                    <el-radio-group v-model="formItem.send_type">
                        <el-radio label="1">链接发送
                            <el-tooltip class="item" placement="top">
                                <i class="el-icon-question pointer"></i>
                                <div slot="content">
                                    <p>在正文中增加下载链接，点击后将附加下载至本地或在线打开（取决于浏览器本身属性）。下载的压缩包名称取邮件标题名称。</p>
                                    <p>推荐使用此方法，可规避附件问题造成的邮件太大，并且加强发送速度！</p>
                                </div>
                            </el-tooltip>
                        </el-radio>
                        <el-radio label="2">作为附件发送
                            <el-tooltip class="item"  placement="top">
                                <i class="el-icon-question pointer"></i>
                                <div slot="content">
                                    <p>将Excel作为附件增加在邮件中，若附件压缩，则压缩包名取邮件标题名称。</p>
                                    <p>不推荐使用此方法，附件可能造成邮件太大无法发送，并且影响加载与发送速度！</p>
                                </div>
                            </el-tooltip>
                        </el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="附件是否压缩：" prop="is_send"  v-if="formItem.is_send=='1'&&formItem.send_type=='2'" class="label-required">
                    <el-radio-group v-model="formItem.zip_send">
                        <el-radio label="0">不压缩</el-radio>
                        <el-radio label="1">压缩</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
        </div>
        <div slot="footer" class="dialog-footer tac pt8">
            <el-button type="default" @click="handleClose" class="action-btn mr20">取消</el-button>
            <el-button type="primary" @click="handleSubmit" class="action-btn ml20">保存</el-button>
        </div>
    </el-dialog>
</template>

<script>
    import {mapGetters} from 'vuex'
    import WEditor from '../../../components/editor';
    import { htmlBorder } from "@/utils";
    export default {
        name: "mailConfigModal",
        components:{
            WEditor,
        },
        props:{
            data:Object,
        },
        data(){
            const direction_email = (rule,value,callback)=>{
                if(!value){
                    callback(new Error('请输入收件人邮箱'));
                }else{
                    let reg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i;
                    let mailArr = value.replace(/\;/g,",").split(',');
                    if(mailArr.every(item=>reg.test(item))){
                        callback();
                    }else{
                        callback(new Error('请输入正确邮箱'));
                    }
                }
            };
            const email = (rule,value,callback)=>{
                if(!value) return callback();
                let reg = /^[_a-z0-9-]+(\.[_a-z0-9-]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,})$/i;
                let mailArr = value.replace(/\;/g,",").split(',');
                if(mailArr.every(item=>reg.test(item))){
                    callback();
                }else{
                    callback(new Error('请输入正确邮箱'));
                }
            };
            const title = (rule,value,callback)=>{
                let reg = /[\[\]/\\*:\s?"<>|']/im;
                if(!value){
                    callback(new Error('请输入邮件标题'));
                }else if(value.length>40){
                    callback(new Error('邮件标题不能超过40个字'));
                }else if(reg.test(value)){
                    callback(new Error('邮件标题含有非法字符：/\\*:?"<>|  []和空格'))
                }else{
                    callback();
                }
            };

            return {
                dialogVisible:false,
                formItem:{
                    direction_email:'',
                    email:'',
                    title:'',
                    body:'',
                    title_date:'1',
                    is_send:'1',
                    send_type:'1',
                    zip_send:'0',
                },
                rules:{
                    direction_email:[
                        { validator:direction_email ,trigger:'blur'}
                    ],
                    email:[
                        { validator:email, trigger:'blur'}
                    ],
                    title:[
                        {validator:title, trigger:'blur'}
                    ],
                },
            }
        },
        computed:{
            ...mapGetters([
                'name',
                'mobile',
                'email',
            ])
        },
        methods:{
            handleClose() {
                this.dialogVisible = false;
                this.resetForm();
            },
            hideModal(){
                this.handleClose();
                this.$emit('close');
            },
            resetForm(){
                console.log('resetForm');
                this.formItem = {
                    direction_email:'',
                    email:'',
                    title:'',
                    body:'',
                    is_send:'1',
                    send_type:'1',
                    zip_send:'0',
                    title_date:'1',
                };
                this.$refs.form.resetFields();
            },
            showModal(){
                this.dialogVisible = true;
                this.$nextTick(()=>{
                    let data = this.data||{};
                   let defaultBody = '<p>Dear all，附件的日报表，请查阅！</p><p></p><p></p><div>{__AUTO_FILL_LAST_WEEK_TOTAL__}</div><p> </p><p> </p><p>Best Regards<br>' +this.name + '<br>玩咖欢聚 | 万咖壹联<br>运营中心</p><p></p><p>Mobile：'+this.mobile +'<br>Email：' + this.email + '<br>Address: 北京市朝阳区酒仙桥路10号恒通商务园B22座4层/广州市天河区黄埔大道中664号保利创融广场太平洋保险大厦9层920-922号<br>玩咖欢聚：www.wankacn.com<br>万咖壹联: www.wankaonline.com</p>';
                   this.formItem.direction_email = data.direction_email.replace(/\;/g,",");
                   this.formItem.email = data.email.replace(/\;/g,",");
                   this.formItem.title = data.title;
                   this.formItem.body = data.body||defaultBody;
                   this.formItem.is_send = data.is_send||'1';
                   this.formItem.send_type = data.send_type||'1';
                   this.formItem.zip_send = data.zip_send||'0';
                   this.formItem.title_date = data.title_date;
                   this.$refs.wEditor.setContent(data.body||defaultBody);
                });
            },
            handleSubmit(){
                this.$refs.form.validate((valid) => {
                    if (valid) {
                        let mailCon = this.$refs.wEditor.getContent();
                        let mailText = this.$refs.wEditor.getContentText();
                        if(mailText.length<=0){
                            return this.$message.error('请输入邮件内容');
                        }
                        this.formItem.body = htmlBorder(mailCon);
                        this.$emit('save',{...this.formItem});
                        this.hideModal();
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style lang="scss" scoped>
    .content-wrap{
        max-height: 65vh;
        overflow-y: auto;
    }
    .remarks p{
        margin-bottom: 0;
        color:red;
        &.remarks_text {
            text-indent: 24px;
        }
    }
</style>
